<template>
  <div class="doExam" v-loading.fullscreen="commitStatus">
    <div
      id="my-calculator"
      style="display: none;"
    ></div>
    <div class="header">
      <a href="//www.chinaacc.com" target="_blank" title="正保会计网校"><div class="logo"></div></a>
    </div>
    <div class="main">
      <!--left-->
      <div class="side-l">
        <h3 class="msf">考生信息</h3>
        <div class="photo"></div>
        <ul>
          <li><strong>姓名：</strong><br>{{userName}}</li>
          <li><strong>准考证号：</strong><br>{{zkzID}}</li>
          <li><strong>证件号码：</strong><br>110000000018125696</li>
          <li><strong>科目名称：</strong><br>{{courseName}}</li>
        </ul>
      </div>
      <!--right-->
      <div class="main-con" >
        <div v-show="isVisibleQueDetail">
          <div class="tit clearfix">
            <div class="tex">
              <h3>一、{{currentQuestion.viewTypeName}}&nbsp;&nbsp;&nbsp;当前题号：第{{currentQuestion.serialNum}}题   总题数：<em>{{quesShowList.length}}</em>题</h3>
              <li></li>
            </div>
            <div class="more">
              <TimerChapter :end-times.sync="endTimes" ref="countDown"/>
              <div class="bj" @click="markToggleFn">{{currentQuestion.isMark ==1?"已标记":"标记"}}</div>
            </div>
          </div>
          <!-- 单选题 -->
          <template v-if="currentQuestion.quesTypeID === 1">
            <exam-single-choice />
          </template>
        </div>
        <exam-ques-list
          v-if="isVisibleQueList"
          @quesFn="changeByQueList"
          @backToPaper="toggleQuesList"
          @savePaper="endToSave"
        />
      </div>
      <!--bottom-->
      <div class="footBottom" :class="[!isVisibleQueDetail?'bot':'']">
        <a
          href="javascript:void (0)"
          @click="runCalc"
          class="a1"
          v-show="isVisibleQueDetail"
        >计算器</a>
        <a
          href="javascript:void (0)"
          @click="changeQues('prev')"
          v-show="isVisibleQueDetail"
          :disabled="preDisabled"
          :class="[{ preDisabled: preDisabled }, 'a2']"
        >&lt; 上一题</a>
        <a
          href="javascript:void (0)"
          @click="changeQues('next')"
          v-show="isVisibleQueDetail"
          :disabled="nextDisabled"
          :class="[{ nextDisabled: nextDisabled }, 'a3']"
        >下一题 &gt;</a>
        <a
          href="javascript:void (0)"
          @click="toggleQuesList(true,'1')"
          class="a4"
          v-show="isVisibleQueDetail"
        >选题</a>
        <a
          href="javascript:void (0)"
          @click="endToSave"
          class="a5"
        >结束考试</a>
        <a
          href="javascript:void (0)"
          @click="backExam"
          class="a6"
          v-show="!isVisibleQueDetail"
        >返回继续答题</a>
      </div>
    </div>
    <!--<ten-minutes :visible.sync="tenMinutesFlag" />-->
    <exam-end
      :visible.sync="endExamFlag"
      :isHaveSubjective="isHaveSubjective"
      @viewResults="viewResults"
      @subjectiveQuestionsStore="subjectiveQuestionsStore"
    />
  </div>
</template>
<script>
  import {
    TimerChapter,
    ExamQuesList,
    ExamSingleChoice,
    examEnd
  } from '@components/exam'
  import mixin from './mixins'
  import { parseNumber, getCookie } from "@/utils"

  window._calc_element = 'my-calculator'

  export default {
    name: 'doExamChapter',
    components: {
      TimerChapter,
      ExamQuesList,
      ExamSingleChoice,
      examEnd
    },
    mixins: [mixin],
    data() {
      return {
        //基础参数
        isStart: false,
        siteCourseID: 0,//课程ID
        courseID: 0,
        courseName: '',//课程名称
        flag: '',//考试类型
        majorID: 0,//辅导ID
        temp: '',//试卷类型（1，新试卷  2，未完成试卷）
        bizID: '',//试卷ID
        spendTime: 0,//试卷消耗时间
        uid: '',//用户ID
        endTimes: 0,
        spendTimeTotle: 0,
        timerMode: 0, //计时种类（1：倒计时；2、正向计时）
        timer: null, //计时器
        isVisibleQueDetail: true, //题目
        isVisibleQueList: false,  //试题列表
        isVisibleUserInfo: false,  //考生信息弹框
        endExamFlag: false,  //结束考试弹框
        //tenMinutesFlag: false, //十分钟倒计时弹框
        //visibleSub: false,//主观题评分弹框
        isHaveSubjective: false,//是否含有主观题
        alertWindow: {
          // 交卷弹窗
          show: false,
          courseName: '',
          unAnswerCount: 0,
          allQuestions: 0,
          isMultipleSelection: false // 是否多选题只选了一个答案
        },
        questionsMap: [],
        chapterID: 0, //章ID
        exerciseTime: 0,//练习时间
        strategy: '',//练习策略
        exerciseName: '',//练习名称
        paperRedo: 0,//练习名称
        isVisibleFuJian: true,//附件是否显示
        zkzID: '',
        mainSize: '16px',
        commitStatus: false, // 提交接口 执行状态
        userName:''
      }
    },
    watch: {
      endTimes(newVal) {
        document.title = this.timeFilter(newVal)
        /*if (newVal === 600) {
         this.tenMinutesFlag = true
       }*/
        if (newVal === 15 && this.timerMode == 1) {
          clearInterval(this.timer)
        }
        if (!this.endExamFlag && newVal === 0) {
          this.endToSubmit()
        }
      }
    },
    async mounted() {
      const { flag } = this.$route.params
      const { siteCourseID, temp, bizID = '', spendTime = 0, courseID, chapterID, paperRedo, zkzID } = this.$route.query
      const { majorID } = this.$categoryInfo
      this.flag = flag === 'paidExam' ? '' : flag
      this.majorID = majorID
      this.zkzID = zkzID
      this.courseID = Number(courseID)
      if (this.courseID === 276) this.isShowTable = true
      this.chapterID = Number(chapterID)
      this.paperRedo = Number(paperRedo)
      this.siteCourseID = parseNumber(siteCourseID)
      this.temp = parseNumber(temp)
      this.bizID = parseNumber(bizID)
      this.spendTime = Number(spendTime)
      this.uid = parseNumber(getCookie('cdeluid') || '')
      this.strategy = getCookie('strategy') && JSON.parse(getCookie('strategy'))
      this.exerciseTime = Number(getCookie('exerciseTime'))
      this.exerciseName = getCookie('exerciseName')
      this.userName = getCookie('username') || ''
      await this.initExam()

      //计算器实例化
      this.$nextTick(() => {
        window.SetCalcType()
      })
    },
    methods: {
      backExam() {
          this.isVisibleQueDetail = true
          this.isVisibleQueList = false
      }
    }
  }
</script>
<style lang="scss" scoped>
  $bgUrl: '../../assets/images';
  .doExam{
    .header{
      position:absolute;
      z-index:3;
      top:0;
      right:0;
      left:0;
      width:100%;
      background:url("//member.chinaacc.com/web-qz/resources/images/jjcy/bg1.gif") repeat-x;
      .logo{
        width:534px;
        height:72px;
        padding:0 0 0 5px;
        background: url("~@/assets/images/entry/title.jpg") no-repeat;
        cursor:pointer;
      }
    }
    .main{
      position:absolute;
      z-index:1;
      top:72px;
      right:0;
      bottom:0;
      left:0;
      border:1px solid #b7dbff;
      .side-l{
        width:189px;
        position:absolute;
        top:0;bottom:0;
        left:0;
        background:#e1f0ff;
        border-right:1px solid #b7dbff;
        padding:0 0 0 20px;
        overflow:auto;
        h3{
          font-size:20px;
          line-height:32px;
          padding:10px 0;
          color:#086fc4;
          font-weight:bold;
        }
        .photo{
          width:142px;
          height:186px;
          background:url("~@/assets/images/fund/photo.png") center center no-repeat;
          background-size: 142px 186px;
        }
        ul{
          padding:10px 10px 0 0;
          font-size: 12px;
          li{
            padding:0 0 6px 0;
            line-height:24px;

          }
        }

      }

      .main-con{
        position:absolute;
        _position:static;
        top:0;
        right:0;
        bottom:63px;
        left:190px;
        overflow:hidden;
        _height:100%;
        _margin-left:190px;
        background:#e1f0ff;
        .tit{ height:73px; background:#c9e4ff; width:100%;
          .tex{ float:left; width:65%; padding:10px 0 10px 20px;
            h3{ font-size:14px; line-height:20px; padding:0 0 6px 0; font-weight:bold;}
            em{ color:#ff3131;}
            p{ line-height:20px;}

          }
          .more{
            float:right;
            padding:8px 10px 0 0;
            _margin-top:8px;
            .bj{
              float: right;
              width: 56px;
              height: 28px;
              line-height: 28px;
              text-align: center;
              border: 1px solid #6dacdc;
              background: #e2f2fc;
              color: #086ec3;
              cursor: pointer;
              font-size: 12px;
              input{
                border:none;
              }
            }
          }
        }


      }

      .footBottom{
        height: 64px;
        line-height: 64px;
        background: #e1f0ff;
        border-top: 1px solid #e1f0ff;
        padding: 0 50px;
        position: absolute;
        z-index: 3;
        right: 0;
        bottom: 0;
        left:190px;
        a{
          display: inline-block;
          width: 90px;
          height: 34px;
          line-height: 32px;
          font-size: 16px;
          border: 1px solid #75b2e0;
          border-radius: 3px;
          margin: 0 20px 0 0;
          text-decoration: none;
          color: #225a86;
        }
        .a1 {
          text-indent: 30px;
          background: url(//member.chinaacc.com/web-qz/resources/images/jjcy/i2.gif) no-repeat 11px 9px #e2f2fc;
        }
        .a2{
          text-indent:10px;
          background:#239CF8;
          color:#fff;
        }

        .a3{text-indent:15px;
          background:#239CF8;
          color:#fff;
        }
        .a4{
          text-indent: 35px;
          background: url("~@/assets/images/fund/i5.gif") no-repeat 11px 9px #e2f2fc;
        }
        .a5{
          width:118px;
          text-indent: 35px;
          border: 1px solid #d36f28;
          background: url("~@/assets/images/fund/i6.gif") no-repeat 11px 11px #ff7e48;
          color: #fff;
          float: right;
          margin-top:18px;
        }
        .a6{
          width:112px;
          background: #1f99f4;
          text-align: center;
          color:#fff;
          float: right;
          margin-top:18px;
        }
        .preDisabled,.nextDisabled{
          background:rgb(167, 175, 181);
          color:#fff;
        }
      }

      .bot{
        background:#fff !important;
        border-top:none !important;
      }
    }

  }
</style>
